export const scrollDetection = () =>
{
	const el = document.querySelector(".jsSiteIcons");
	const helloBar = document.querySelector('.jsHelloBar');
	let marginHeight = 0;

	if (helloBar)
	{
		marginHeight = helloBar.clientHeight;
	}

	function handleCallback([e])
	{
		// console.log("e.intersectionRatio is " + e.intersectionRatio);
		// console.log("is e.intersectionRatio greater than 0? " + (e.intersectionRatio > 0));
		document.documentElement.classList.toggle("is-scrolled", e.intersectionRatio < 1);
	}

	let options = {
		rootMargin: `${marginHeight}px`, // how far do we need to scroll before it gets detected?
		threshold: 1
	}

	const observer = new IntersectionObserver(handleCallback, options);

	observer.observe(el);

};